export default __webpack_public_path__ + "static/media/drills.8a704064.jpg";